/* unplugin-vue-components disabled */import script from "./Invest.vue?vue&type=script&setup=true&lang=js"
export * from "./Invest.vue?vue&type=script&setup=true&lang=js"

import "./Invest.vue?vue&type=style&index=0&id=348f3576&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348f3576"]])

export default __exports__